const jQuery = window.jQuery;
import { alertCtk, alertCtkApiError, fillCountries } from './utils';
import {
  ajaxUniPostUsingCaptcha,
  ajaxUniPost,
  checkOkStatusInSuccessFunc,
} from './ajaxutils';
import {
  getValue,
  bindValidateHandlers,
  validateProfilePart,
} from './validate';
import { loginAndToProfile } from './login';

window.ctkerrormessage = 'Vyplňte všechny povinné položky formuláře';

export function validate() {
  validateProfilePart('register', false);
}
export function validateSilent() {
  validateProfilePart('register', true);
}

function sendRegister(event) {
  console.log('submitting form');
  const f = jQuery('#formsubmit');
  if (f.hasClass('notusable')) {
    alertCtk(window.ctkerrormessage);
  } else {
    ajaxRegisterSubmit();
  }
  event.preventDefault();
  return false;
}

export function registerBindHandlers() {
  const vals = [
    'comapny',
    'name',
    'surname',
    'email',
    'phone',
    'street',
    'city',
    'psc',
    'country',
    'ic',
    'dic',
    'passwd',
    'passwd2',
  ];
  vals.forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });
  ['souhlas'].forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });

  jQuery('#formsubmit').on('click', sendRegister);

  jQuery(document).on('click', function (e) {
    if (jQuery(e.target).closest('#login-form').length === 0) {
      jQuery('#login-form').removeClass('visible');
    }
  });
  fillCountries();
  // bindValidateHandlers();
  validateSilent();
}

export function ajaxRegisterSubmit() {
  const data = {};
  data.company = getValue('company');
  data.name = getValue('name');
  data.surname = getValue('surname');
  data.email = getValue('email');
  data.phone = getValue('phone');
  data.street = getValue('street');
  data.city = getValue('city');
  data.psc = getValue('psc');
  data.country = getValue('country');
  data.ic = getValue('ic');
  data.dic = getValue('dic');
  data.passwd = getValue('passwd');

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('save register returned');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const res = { ...parsed };
    if (res.status === 'userExists') {
      alertCtk('Chyba - tento uživatel už existuje');
      return false;
    }
    if (res.status === 'unknownError') {
      alertCtkApiError();
      return false;
    }
    loginAndToProfile(data.email, data.passwd);
    const crc = parsed.crc;
    delete res.crc;
  };
  ajaxUniPostUsingCaptcha('RegisterUser', data, successFunc, 'register');
  //ajaxUniPost('RegisterUser', data, successFunc);
}
